// @flow

import React from 'react'
import {small, medium, large} from '../../stylesheets/sizes.css'
import mapDataToProps from './mapDataToProps'
import style from './style.css'

// Import components
import {OppslutningEnkelGraph} from '../../components/oppslutningEnkel/OppslutningEnkelGraph'
import {ElementQuery} from '../../components/shared/ElementQuery'

const breakPoints = [
  {className: small, width: 345},
  {className: medium, width: 440},
  {className: large, width: 690}
]

function EnblokksvisningWidget(data: any) {
  const {description, id, graphProps, source, title} = mapDataToProps(data)

  return (
    <div
      className={style.oppslutningEnkelWidget}
      id={id}
      data-props={encodeURIComponent(JSON.stringify(data))}
    >
      <ElementQuery sizes={breakPoints}>
        <header className={style.oppslutningEnkelWidget__header}>
          <h2 className={style.oppslutningEnkelWidget__title}>
            {title}
          </h2>
          {description &&
            <div className={style.oppslutningEnkelWidget__description}>
              {description}
            </div>}
        </header>
        <OppslutningEnkelGraph {...graphProps} />
        {source &&
          <div className={style.oppslutningEnkelWidget__source}>
            {source}
          </div>}
      </ElementQuery>
    </div>
  )
}

export default EnblokksvisningWidget



// WEBPACK FOOTER //
// ./src/shared/containers/OppslutningEnkelWidget/index.js